module.exports = __webpack_public_path__ + "static/media/dg.28cc66b8.svg";